import React from 'react';
import PropTypes from 'prop-types';
import { isEmail } from 'react-multi-email';

import Modal from '../modal';
import InputWithHeader from '../input-with-header';

import styles from './styles.css';

export default function ExportModal({ show, onClose, onExport }) {
  const [email, setEmail] = React.useState('');
  const [invalidEmail, setInvalidEmail] = React.useState(false);

  const handleOnExport = () => {
    if (isEmail(email)) {
      setInvalidEmail(false);
      onExport(email);
      return true;
    }
    setInvalidEmail(true);
    return false;
  };

  const handleOnEmailChange = ({ currentTarget: { value } }) => {
    setEmail(value);
  };

  const handleOnModalClose = () => {
    onClose();
    setEmail('');
    setInvalidEmail(false);
  };

  return (
    <Modal show={show} onClose={handleOnModalClose} saveButtonText="EXPORT" onSave={handleOnExport}>
      <div className={styles.exportModalWrapper}>
        <div className={styles.exportImage}><img src="/images/app/export-header-icon.svg" alt="export-header-icon" /></div>
        <div className={styles.exportModalContainer}>
          <div><h3>We&apos;re getting your data ready</h3></div>
          <div>
            <p>
              {`
                We're just getting things ready but first, let us know which email you want your data sent to,
                and we'll ship it off to that address when it's ready!
              `}
            </p>
          </div>
          <div className={styles.emailInputContainer}>
            <InputWithHeader
              placeholder="Email"
              error="Not a valid email"
              onChange={handleOnEmailChange}
              value={email}
              isInvalid={invalidEmail}
            />
          </div>
        </div>
      </div>

    </Modal>
  );
}

ExportModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onExport: PropTypes.func,
};

ExportModal.defaultProps = {
  show: false,
  onClose: () => { },
  onExport: () => { },
};
